import { isDmStagingResponse, isStageDmResponse, } from '@urbanik/api-contracts';
export class DmStagingApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'DmStagingApiError';
    }
}
const kind = (status) => status === 401
    ? 'unauthorized'
    : status === 403
        ? 'forbidden'
        : status === 400
            ? 'invalid'
            : 'unavailable';
export async function getDmStaging(base, input = {}, signal) {
    const url = new URL(`${base.replace(/\/$/, '')}/identity/financial-migration/dm-staging`);
    Object.entries(input).forEach(([key, value]) => {
        if (value !== undefined && value !== '')
            url.searchParams.set(key, String(value));
    });
    let response;
    try {
        response = await fetch(url, {
            credentials: 'include',
            headers: { Accept: 'application/json' },
            signal: signal ?? null,
        });
    }
    catch {
        throw new DmStagingApiError('unavailable', 'No pudimos consultar el staging DM.');
    }
    const body = await response.json().catch(() => null);
    if (!response.ok)
        throw new DmStagingApiError(kind(response.status), 'No pudimos consultar el staging DM.');
    if (!isDmStagingResponse(body))
        throw new DmStagingApiError('invalid', 'La respuesta del staging DM no es válida.');
    return body;
}
export async function stageDmWorkbook(base) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/financial-migration/dm-staging`, {
            method: 'POST',
            credentials: 'include',
            headers: { Accept: 'application/json' },
        });
    }
    catch {
        throw new DmStagingApiError('unavailable', 'No pudimos transformar las matrices DM.');
    }
    const body = await response.json().catch(() => null);
    if (!response.ok)
        throw new DmStagingApiError(kind(response.status), 'No pudimos transformar las matrices DM.');
    if (!isStageDmResponse(body))
        throw new DmStagingApiError('invalid', 'La confirmación del staging DM no es válida.');
    return body;
}
